import { gql } from 'apollo-angular';

export var nav_search_people = gql`
  query navSearchPeople(
    $searchLike: String!
    $search: String!
    $limit: Int!
    $page: Int
  ) {
    search_people(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      page: $page
    ) {
      data {
        id
        name
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;
